var _excluded = ["value", "onChange", "onBlur", "currency", "placeholder", "isDisabled", "isReadOnly", "errorMessage", "testKey", "allowNegativeValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Input } from '@chakra-ui/react';
import { useRef, useState } from 'react';
import MaskedInput from 'react-text-mask';
import { Group } from '../../../containers';
import { useIntl } from '../../../theme/i18n';
import { forwardRef } from '../../../utils';
import { createNumberMask } from '../../../utils/create-number-mask-utils';
import { convertCurrencyToNumber, defaultCurrency, defaultIntegerLimit, getCurrencyDetails } from '../../../utils/currency-utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { Typography } from '../../dataDisplay';
import { Box } from '../Box';
/**
 * @private Please use `TableAmountInputProps` from `@melio/penny`.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * @private Please use `Table.AmountInput` from `@melio/penny`.
 */
export var _TableAmountInput = forwardRef((props, ref) => {
  var {
    formatCurrency
  } = useIntl();

  var {
    value,
    onChange,
    onBlur,
    currency = defaultCurrency,
    placeholder = formatCurrency(0, currency),
    isDisabled,
    isReadOnly,
    errorMessage,
    testKey,
    allowNegativeValue = true
  } = props,
      otherProps = _objectWithoutProperties(props, _excluded);

  var styles = useMultiStyleConfig('_TableAmountInput', {});
  var maskProps = {
    as: MaskedInput,
    guide: false,
    mask: createNumberMask({
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ',',
      allowDecimal: true,
      decimalSymbol: '.',
      decimalLimit: 2,
      integerLimit: defaultIntegerLimit,
      allowNegative: allowNegativeValue
    })
  };

  var getTestId = childName => ['table-amount-input', childName, testKey].filter(Boolean).join('-');

  var {
    sign
  } = getCurrencyDetails(currency);
  var [inputValue, setInputValue] = useState(value !== null && value !== void 0 ? value : '');

  var handleChange = event => {
    if (event.target.value === '') {
      setInputValue(sign);
    } else {
      setInputValue(event.target.value);
    }

    var parsedValue = event.target.value === '' ? event.target.value : convertCurrencyToNumber(event.target.value).toString();
    onChange === null || onChange === void 0 ? void 0 : onChange({
      target: {
        value: parsedValue
      }
    });
  };

  var inputRef = useRef(null);

  var handleFocus = () => {
    if (inputRef.current) {
      var input = inputRef.current.inputElement; // We need `setTimeout` to get the correct value length.

      setTimeout(() => {
        var {
          length
        } = input.value; // Moves the cursor to the end.

        input.setSelectionRange(length, length);
      }, 0);
    }
  };

  var handleBlur = event => {
    if (inputValue === sign) {
      setInputValue('');
      onBlur === null || onBlur === void 0 ? void 0 : onBlur({
        target: {
          value: ''
        }
      });
    } else {
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }
  };

  return /*#__PURE__*/_jsxs(Group, _objectSpread(_objectSpread({
    "data-component": "_TableAmountInput",
    ref: ref
  }, otherProps), {}, {
    variant: "vertical",
    spacing: "xxxs",
    width: "full",
    children: [/*#__PURE__*/_jsx(Input, _objectSpread(_objectSpread({}, maskProps), {}, {
      ref: inputRef,
      sx: styles['field'],
      value: inputValue,
      placeholder: placeholder,
      onChange: handleChange,
      onBlur: handleBlur,
      onFocus: handleFocus,
      onClick: e => e.stopPropagation(),
      isDisabled: isDisabled,
      isReadOnly: isReadOnly,
      "data-error": errorMessage || undefined,
      "data-testid": getTestId()
    })), errorMessage && /*#__PURE__*/_jsx(Box, {
      __css: styles['errorMessage'],
      children: /*#__PURE__*/_jsx(Typography.Description, {
        label: errorMessage,
        isInvalid: true,
        "data-testid": getTestId('error-message')
      })
    })]
  }));
});
_TableAmountInput.displayName = '_TableAmountInput';
//# sourceMappingURL=_TableAmountInput.js.map